import { useApiClient } from "@/composables/useApiClient";
import { AppBookmarkableEnum } from "@/services/fobizzToolsApi";
import { useUserStore } from "@/stores/user";
import { ref, watch } from "vue";

export function useBookmark(
  objType: AppBookmarkableEnum,
  objId: string,
  isAuthor: ComputedRef<boolean>
) {
  const { bookmarks: bookmarksService } = useApiClient();
  const queryClient = useQueryClient();
  const userStore = useUserStore();
  const { t } = useI18n();

  const bookmarked = ref<boolean>(false);

  const checkBookmark = async () => {
    if (isAuthor.value || userStore.isVisitor || !userStore.isAuthenticated)
      return;

    try {
      const response = await bookmarksService.checkBookmark({
        objType,
        objId,
      });
      bookmarked.value = response.bookmarked;
    } catch (error) {
      console.error("Error checking bookmark:", error);
    }
  };

  const toggleBookmark = async () => {
    if (isAuthor.value || userStore.isVisitor) return;

    try {
      const response = await bookmarksService.toggleBookmark({
        objType,
        objId,
      });

      bookmarked.value = response.bookmarked;

      queryClient.invalidateQueries({ queryKey: ["materials"] });

      if (bookmarked.value) {
        flash(FlashKindEnum.INFO, t("flash.bookmarkSuccess"));
      } else {
        flash(FlashKindEnum.INFO, t("flash.unbookmarkSuccess"));
      }
    } catch (error) {
      console.error("Error toggling bookmark:", error);
    }
  };

  watch(
    () => userStore.user?.id,
    async () => {
      await checkBookmark();
    },
    { immediate: true }
  );

  return {
    bookmarked,
    toggleBookmark,
  };
}
